import styled from "@emotion/styled";

const ButtonContainer = styled.div([
    {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      rowGap: 0,
      columnGap: 30,
      marginTop: 40,
      marginBottom: 0,
      marginRight: 20,
      marginLeft: 20,
    },
    `
      @media (max-width: 767px) {
        flex-direction: column;
      }
    `
  ]);

  export default ButtonContainer;